import { createApp } from 'vue';
// Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import {
  VApp,
  VContainer,
  VCard,
  VCardTitle,
  VCardText,
  VCardSubtitle,
  VRow,
  VCol,
  VProgressCircular,
  VChip,
  VIcon,
  VBtn,
} from 'vuetify/components';
import * as directives from 'vuetify/directives';
import moment from 'moment';
import 'moment/locale/de';

import App from './App.vue';

export function createSiteApp(router, seed = {}) {
  const vuetify = createVuetify({
    components: {
      VApp,
      VContainer,
      VCard,
      VCardTitle,
      VCardText,
      VCardSubtitle,
      VRow,
      VCol,
      VProgressCircular,
      VChip,
      VIcon,
      VBtn,
    },
    directives,
    icons: {
      defaultSet: 'mdi', // Setze das Standard-Icon-Set auf 'mdi'
    },
    theme: {
      themes: {
        light: {
          colors: {
            darkbackground: '#343541',
            //primary: '#00963f',
            primary: '#233f3b',
            secondary: '#80694f',
          },
        },
      },
    },
  });

  const app = createApp(App);

  moment.locale('de');
  app.config.globalProperties.$moment = moment;

  app.use(router);

  app.use(vuetify);

  app.provide('gallerySeed', seed);
  return app;
}
